import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import { getSettingsCategoryGroups } from "./settings-categories";
import {
  ControlStack,
  ControlCopy,
  ControlSection,
  ControlRow,
} from "./panels/DataControlParts.web";
import { SettingsRouteScrollView } from "./SettingsRouteScrollView.web";

export function SettingsRouteIndex() {
  const { t } = useTranslation("common");
  const router = useRouter();
  const groups = getSettingsCategoryGroups();
  return (
    <SettingsRouteScrollView>
      <ControlStack gap={28}>
        <ControlCopy>{t("settings.controls.settingsHint")}</ControlCopy>
        {groups.map((group) => (
          <ControlSection key={group.labelKey} title={t(group.labelKey)}>
            {group.categories.map((category) => {
              const id = category.id;
              return category ? (
                <ControlRow
                  key={id}
                  title={t(category.labelKey)}
                  description={
                    id === "privacy"
                      ? t("settings.cvPrivacy.description")
                      : id === "dataManagement"
                        ? t("settings.dataManagement.description")
                        : undefined
                  }
                  onPress={() => router.push(category.nativeRoute as never)}
                />
              ) : null;
            })}
          </ControlSection>
        ))}
      </ControlStack>
    </SettingsRouteScrollView>
  );
}
